import api from "./index";

// Appointments summary
export const getAppointmentsSummary = async () => {
  return api.get("dashboard/appointments/summary");
};

// Active patients count
export const getActivePatients = async () => {
  return api.get("dashboard/patients/active");
};

// Payments summary
export const getPaymentsSummary = async () => {
  return api.get("dashboard/payments/summary");
};

// Combined data: appointments, patients, payments
export const getCombinedData = async () => {
  return api.get("dashboard/appointments-patients-payments-data");
};

// Analytics by year and month (1-12)
export const getAnalytics = async (year: number, month: number) => {
  return api.get(`dashboard/analytics`, { params: { year, month } });
};

export type AppointmentsSummary = {
  totalAppointments: number;
  completedAppointments: number;
  remainingAppointments: number;
  progressPercentage: number;
};

export type PaymentsSummary = {
  totalPayments: number;
  pendingPayments: number;
  completedPayments: number;
  progressPercentage: number;
};

export type AnalyticsResponse = {
  newPatients: {
    categories: string[];
    series: { name: string; data: number[] }[];
  };
  appointmentsOverview: {
    monthLabel: string;
    categories: string[];
    series: { name: string; data: number[] }[];
  };
  payments: {
    label: string;
    pending: number;
    total: number;
    progress: number; // 0..1
  };
};


